import React, { useCallback, useEffect, useState } from 'react';
import cogoToast from 'cogo-toast';

import {
  useDeleteSbatGroupLessonMutation,
  useGetSbatGroupQuery,
} from 'features/classCreation';
import CreateSbatGroupLessonModal from '../CreateSbatGroupLessonModal';
import ToggleChip from 'components/ToggleChip';

function findByLessonType(lessons, lessonType) {
  return lessons?.find((lesson) => lesson.lesson_type === lessonType);
}

export default function SbatGroupLessonChip({ sbatGroup, lessonType, title }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteLesson, { isSuccess, error }] =
    useDeleteSbatGroupLessonMutation();

  const { lesson } = useGetSbatGroupQuery(sbatGroup.id, {
    selectFromResult: ({ data }) => ({
      lesson: findByLessonType(data?.data?.academy_topic.lessons, lessonType),
    }),
  });

  const handleModalOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lesson is successfully deleted!');
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in deleting the lesson. Please try again later!'
      );
    }
  }, [error, isSuccess]);

  const handleLessonDelete = useCallback(() => {
    if (window.confirm('Are you sure, you want to delete this lesson?')) {
      deleteLesson({ lessonId: lesson?.id, sbatGroupId: sbatGroup.id });
    }
  }, [sbatGroup.id, deleteLesson, lesson?.id]);

  return (
    <>
      <CreateSbatGroupLessonModal
        title={title}
        handleClose={handleModalClose}
        lessonType={lessonType}
        isOpen={modalOpen}
        sbatGroup={sbatGroup}
      />
      <ToggleChip
        isAdded={Boolean(lesson)}
        onAdd={handleModalOpen}
        onRemove={handleLessonDelete}
        label={title}
        className="m-r-xs m-b-xxs"
      />
    </>
  );
}
